// Environment configuration component
// This runs after Create React App has loaded environment variables

import { useEffect } from 'react';
import logger from '../utils/logger';

const DEFAULTS = {
  api: 'http://localhost:8080/api/',
  environment: 'development',
  keycloak: {
    url: 'https://sso.dev.chainsmart.id',
    realm: 'demo',
    clientId: 'smartshield-app-dev',
  },
  version: '1.0.0',
};

function coerce(value, fallback) {
  // Treat '', null, undefined as falsy -> use fallback
  if (value === '' || value === null || value === undefined) return fallback;
  return value;
}

export default function EnvironmentConfig() {
  useEffect(() => {
    try {
      const log = (...args) => {
        logger.debug(...args);
      };

      log('🔧 Setting up environment configuration from React app...');
      log('🎯 Environment configuration from React:');

      // Gather values from process.env, falling back to defaults for falsy values
      const api = coerce(process?.env?.REACT_APP_API_PURE, DEFAULTS.api);
      const environment = coerce(process?.env?.REACT_APP_ENVIRONMENT, DEFAULTS.environment);
      const keycloakUrl = coerce(process?.env?.REACT_APP_KEYCLOAK_URL, DEFAULTS.keycloak.url);
      const keycloakRealm = coerce(process?.env?.REACT_APP_KEYCLOAK_REALM, DEFAULTS.keycloak.realm);
      const keycloakClientId = coerce(process?.env?.REACT_APP_KEYCLOAK_CLIENT_ID, DEFAULTS.keycloak.clientId);
      const version = coerce(process?.env?.REACT_APP_VERSION, DEFAULTS.version);

      // Write to window and globalThis
      window.REACT_APP_API_PURE = api;
      window.REACT_APP_ENVIRONMENT = environment;
      window.REACT_APP_KEYCLOAK_URL = keycloakUrl;
      window.REACT_APP_KEYCLOAK_REALM = keycloakRealm;
      window.REACT_APP_KEYCLOAK_CLIENT_ID = keycloakClientId;
      window.REACT_APP_VERSION = version;

      globalThis.REACT_APP_API_PURE = api;
      globalThis.REACT_APP_ENVIRONMENT = environment;
      globalThis.REACT_APP_KEYCLOAK_URL = keycloakUrl;
      globalThis.REACT_APP_KEYCLOAK_REALM = keycloakRealm;
      globalThis.REACT_APP_KEYCLOAK_CLIENT_ID = keycloakClientId;
      globalThis.REACT_APP_VERSION = version;

      // Emit logs in exact format tests expect
      log('  API URL:', api);
      log('  Environment:', environment);
      log('  Keycloak URL:', keycloakUrl);
      log('  Keycloak Realm:', keycloakRealm);
      log('  Keycloak Client ID:', keycloakClientId);
      log('  Version:', version);

      const finalConfig = {
        api,
        environment,
        keycloak: {
          url: keycloakUrl,
          realm: keycloakRealm,
          clientId: keycloakClientId,
        },
        version,
      };

      log('✅ Configuration loaded from environment variables:', finalConfig);
    } catch (err) {
      // Be defensive for test environments
      // Do not throw — tests render the component and inspect side effects
      logger.error('EnvironmentConfig error:', err);
    }
  }, []);

  // This component intentionally renders nothing
  return null;
}
